/**
 * @generated SignedSource<<982a96b0730bd8b8868259286e7d6c05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BidirectionalStickyScroller_facilities$data = ReadonlyArray<{
  readonly agendas: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly copyOverrides: {
    readonly course: {
      readonly plural: string;
    } | null | undefined;
  };
  readonly courses: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"SingleCourseColumn_course">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"ColumnHeaderRow_facilities" | "CourseColumns_facilities" | "useGetFirstLastTimeAcrossCoursesPatron_facilities">;
  readonly " $fragmentType": "BidirectionalStickyScroller_facilities";
}>;
export type BidirectionalStickyScroller_facilities$key = ReadonlyArray<{
  readonly " $data"?: BidirectionalStickyScroller_facilities$data;
  readonly " $fragmentSpreads": FragmentRefs<"BidirectionalStickyScroller_facilities">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "courseIds"
    },
    {
      "kind": "RootArgument",
      "name": "date"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "BidirectionalStickyScroller_facilities",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityCopyOverrides",
      "kind": "LinkedField",
      "name": "copyOverrides",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NounOverride",
          "kind": "LinkedField",
          "name": "course",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plural",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetFirstLastTimeAcrossCoursesPatron_facilities"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ColumnHeaderRow_facilities"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CourseColumns_facilities"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "courseIds",
          "variableName": "courseIds"
        }
      ],
      "concreteType": "CourseConnection",
      "kind": "LinkedField",
      "name": "courses",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CourseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Course",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SingleCourseColumn_course"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "dateGte",
          "variableName": "date"
        },
        {
          "kind": "Variable",
          "name": "dateLte",
          "variableName": "date"
        }
      ],
      "concreteType": "AgendaConnection",
      "kind": "LinkedField",
      "name": "agendas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AgendaEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Agenda",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "4a8a5ef1e70283b5ee9fc87c3ed9edb2";

export default node;
